import { render, staticRenderFns } from "./UserAuthorizationByCallOrSms.vue?vue&type=template&id=177df41e&"
import script from "./UserAuthorizationByCallOrSms.vue?vue&type=script&lang=js&"
export * from "./UserAuthorizationByCallOrSms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('177df41e')) {
      api.createRecord('177df41e', component.options)
    } else {
      api.reload('177df41e', component.options)
    }
    module.hot.accept("./UserAuthorizationByCallOrSms.vue?vue&type=template&id=177df41e&", function () {
      api.rerender('177df41e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/UserAuthorization/components/UserAuthorizationByCallOrSms.vue"
export default component.exports